import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { RouteReuseStrategy } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAuth } from 'angular-auth-oidc-client';
import { routes } from './app.routes';
import { authInterceptor } from './auth/auth-interceptor';
import { authConfig } from './auth/auth.config';
import { httpErrorInterceptor } from './auth/http-error.interceptor';
import { AppRouteReuseStrategy } from './core/route-reuse.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAuth(authConfig),
    provideHttpClient(
      withInterceptors([authInterceptor, httpErrorInterceptor])
    ),
    { provide: LOCALE_ID, useValue: 'en-AU' },
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
  ],
};
